<div class="bg-white rounded-lg p-4 shadow-sm border border-gray-200 h-full">
  <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
    <mat-icon class="mr-2 text-green-600">business</mat-icon>
    Company Details
  </h3>
  <div class="space-y-3">
    <div class="flex items-center justify-between">
      <div class="flex items-center">
        <mat-icon class="mr-2 text-gray-400">corporate_fare</mat-icon>
        <span class="text-sm font-medium text-gray-600 mr-2">Name:</span>
        <span class="text-sm font-semibold">{{ company?.name || "N/A" }}</span>
      </div>
      <div *ngIf="logoUrl" class="ml-4">
        <span
          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
        >
          <mat-icon class="mr-1" style="font-size: 12px">image</mat-icon>
          Has Logo
        </span>
      </div>
    </div>
    <!-- Removed Company ID display -->
    <!-- Logo Preview -->
    <div *ngIf="logoUrl" class="mt-4">
      <div class="flex items-center mb-2">
        <mat-icon class="mr-2 text-gray-400">image</mat-icon>
        <span class="text-sm font-medium text-gray-600">Company Logo:</span>
      </div>
      <div class="relative group">
        <img
          [src]="logoUrl"
          [alt]="company?.name + ' logo'"
          class="w-32 h-32 rounded-lg object-cover border-2 border-gray-300 shadow-md hover:shadow-xl transition-all duration-300 cursor-zoom-in"
        />
        <div
          class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 rounded-lg transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100"
        >
          <button
            mat-icon-button
            (click)="openLogo($event)"
            class="bg-white bg-opacity-90 hover:bg-opacity-100 rounded-full p-2 shadow-lg"
          >
            <mat-icon class="text-gray-700">open_in_new</mat-icon>
          </button>
        </div>
      </div>
      <div class="mt-2 text-xs text-gray-500 truncate">
        {{ logoUrl }}
      </div>
    </div>
    <div *ngIf="!logoUrl" class="mt-4">
      <div class="flex items-center">
        <mat-icon class="mr-2 text-gray-400">image_not_supported</mat-icon>
        <span class="text-sm font-medium text-gray-600"
          >No company logo uploaded</span
        >
      </div>
      <div class="mt-2 text-xs text-gray-500">
        This company doesn't have a logo yet.
      </div>
    </div>
  </div>
  <div
    *ngIf="company?.id || company?._id"
    class="mt-4 border-t border-gray-200 pt-4"
  >
    <a
      mat-stroked-button
      color="primary"
      [routerLink]="['/company', company.id || company._id, 'financial-settings']"
      (click)="$event.stopPropagation()"
    >
      <mat-icon class="mr-2">payments</mat-icon>
      Financial settings
    </a>
  </div>
</div>
